/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';

export const companyPropTypes = {
  acuity_links: PropTypes.shape({
    de: PropTypes.string,
    en: PropTypes.string,
    es: PropTypes.string,
    fr: PropTypes.string,
  }),
  benefits_custom: PropTypes.arrayOf(
    PropTypes.shape({
      deleted: PropTypes.bool,
      description: PropTypes.arrayOf(
        PropTypes.shape({
          content: PropTypes.string,
          lang: PropTypes.string,
        }),
      ),
      icon: PropTypes.string,
      id: PropTypes.string,
    }),
  ),
  benefits_pool: PropTypes.arrayOf(
    PropTypes.shape({
      benefit_group: PropTypes.string,
      icon: PropTypes.string,
      id: PropTypes.string,
      title: PropTypes.string,
    }),
  ),
  colour: PropTypes.string,
  company_name: PropTypes.string,
  company_url: PropTypes.string,
  company_video: PropTypes.string,
  description: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.string,
      lang: PropTypes.string,
    }),
  ),
  diversity_text: PropTypes.string,
  diversity_toggle: PropTypes.bool,
  founded: PropTypes.string,
  glassdoor_rating: PropTypes.string,
  industry: PropTypes.string,
  industry_object: PropTypes.shape({
    display: PropTypes.shape({
      de: PropTypes.string,
      en: PropTypes.string,
      es: PropTypes.string,
      fr: PropTypes.string,
    }),
    mid: PropTypes.string,
  }),
  kununu_rating: PropTypes.string,
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      placeId: PropTypes.string,
    }),
  ),
  logo_url: PropTypes.string,
  other_names: PropTypes.string,
  pictures: PropTypes.arrayOf(PropTypes.string),
  text_colour: PropTypes.string,
};